import React from 'react';
import { useHistory } from 'react-router-dom';
import GoBackIcon from '../../svgs/GoBackIcon';
import './DetailsHeader.scss';

interface IAdminDetailsHeader{
  routeName?:string;
  hasDoubleHeader?:boolean;
  frame?:any;
  pageTitle?:string;
}
const AdminDetailsHeader = ({ hasDoubleHeader, frame, pageTitle }:IAdminDetailsHeader) => {
  const history = useHistory();
  return (
    <div className="header-details-cover">
      <div className="title-cover">
        <GoBackIcon onClick={() => history?.goBack()} />
        {' '}
        {
          pageTitle || ' Transactions'
        }

      </div>
      {
        hasDoubleHeader && <div>{frame}</div>
      }

    </div>
  );
};
export default AdminDetailsHeader;
